<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div
    class="relative min-h-screen bg-cover bg-center bg-no-repeat text-white flex flex-col items-center justify-center px-6"
  >
    <!-- Dark Overlay for Readability -->
    <div class="absolute inset-0 bg-black bg-opacity-50"></div>

    <div class="relative z-10 max-w-4xl">
      <!-- Main Title -->
      <h1
        class="text-4xl md:text-5xl leading-tight"
      >{{ $t('Zorgblik Academie – De leeromgeving voor de zorgprofessional van de toekomst!') }}</h1>

      <!-- Subtitle -->
      <p
        class="mt-5 text-lg md:text-xl font-medium"
      >{{ $t('Werken en ontwikkelen zijn onlosmakelijk verbonden. Bij Zorgblik Academie bouwen we samen aan de toekomst van de zorg.') }}</p>
    </div>
  </div>
</template>